import { render, staticRenderFns } from "./CourseSetting.vue?vue&type=template&id=214ab679&scoped=true&"
import script from "./CourseSetting.vue?vue&type=script&lang=js&"
export * from "./CourseSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ab679",
  null
  
)

export default component.exports